import { render, staticRenderFns } from "./uni-search-bar.vue?vue&type=template&id=26323aff&scoped=true"
import script from "./uni-search-bar.vue?vue&type=script&lang=js"
export * from "./uni-search-bar.vue?vue&type=script&lang=js"
import style0 from "./uni-search-bar.vue?vue&type=style&index=0&id=26323aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26323aff",
  null
  
)

export default component.exports